type IsoDate = string;

export enum FilterType {
  Date = 'date',
  Radio = 'radio',
  Checkbox = 'checkbox',
}

export type FilterOptionValue = string | number | boolean;

export interface BaseOption {
  label: string;
  value: FilterOptionValue;
}

export interface CheckboxOption extends BaseOption {
  is_selected: boolean;
}

export interface RadioOption extends BaseOption {
  is_selected: boolean;
}

export interface DateRange {
  from: IsoDate | null;
  to: IsoDate | null;
}

export interface CheckboxFilter {
  type: FilterType.Checkbox;
  options: CheckboxOption[];
}

export interface RadioFilter {
  type: FilterType.Radio;
  options: RadioOption[];
}

export interface DateFilter {
  type: FilterType.Date;
  min?: IsoDate;
  max?: IsoDate;
  chosen_value: DateRange;
}

export type AnyFilter = CheckboxFilter | DateFilter | RadioFilter;

export type FiltersMap = Record<string, AnyFilter>;

export interface AppliedRadioValue {
  value: FilterOptionValue;
  label: string;
}
export type AppliedCheckboxValue = { value: FilterOptionValue; label: string }[];
export interface AppliedDateValue {
  chosen_value: DateRange;
  label: string;
}

export type AppliedValue = AppliedCheckboxValue | AppliedDateValue | AppliedRadioValue;

export type AppliedFilters = Record<string, AppliedValue>;

export interface FiltersContent<TFilters extends FiltersMap = FiltersMap> {
  filters: TFilters;
  applied: AppliedFilters;
}
